// cursor.service.ts
import { Injectable } from '@angular/core';
import { gsap } from 'gsap';

@Injectable({
  providedIn: 'root',
})
export class CursorService {
  private cursor: HTMLElement | null = null;
  private cursorFollower: HTMLElement | null = null;
  private initialized = false;

  constructor() {
    if (typeof document === 'undefined') {
      return;
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupCursor(), {
        once: true,
      });
      return;
    }

    this.setupCursor();
  }

  private setupCursor(): void {
    if (this.initialized) {
      return;
    }

    this.cursor = document.querySelector('.my-cursor');
    this.cursorFollower = document.querySelector('.cursor-follower');

    if (!this.cursor || !this.cursorFollower) {
      return;
    }

    this.initialized = true;
    this.initCursor();
  }

  ensureInitialized(): void {
    this.setupCursor();
  }

  initCursor(): void {
    if (!this.cursor || !this.cursorFollower) {
      return;
    }

    document.addEventListener('mousemove', (e) => {
      if (!this.cursor) return;
      this.cursor.style.display = 'block';
      gsap.to(this.cursor, {
        x: e.clientX,
        y: e.clientY,
        duration: 0.2,
        ease: 'power2.out',
      });
    });

    document.addEventListener('mousemove', (e) => {
      if (!this.cursorFollower) return;
      this.cursorFollower.style.display = 'block';
      gsap.to(this.cursorFollower, {
        x: e.clientX,
        y: e.clientY,
        duration: 0.5,
        ease: 'power2.out',
      });
    });

    // Listen for mouseleave event on the document or window
    document.addEventListener('mouseleave', () => {
      if (this.cursor) this.cursor.style.display = 'none';
      if (this.cursorFollower) this.cursorFollower.style.display = 'none';
    });
  }

  public hoverElement(): void {
    if (!this.cursor) return;
    gsap.to(this.cursor, { scale: 1.5, duration: 0.2, ease: 'power2.out' });
  }

  public unhoverElement(): void {
    if (!this.cursor) return;
    gsap.to(this.cursor, { scale: 1, duration: 0.2, ease: 'power2.out' });
  }

  changeCursorColor(color: string): void {
    if (!this.cursor) return;
    gsap.to(this.cursor, {
      borderColor: color,
      backgroundColor: color,
      duration: 0.2,
      scale: 2,
      ease: 'power2.out',
    });
  }
  changeCursorColorBack(color: string): void {
    if (!this.cursor) return;
    gsap.to(this.cursor, {
      borderColor: color,
      backgroundColor: color,
      duration: 0.2,
      scale: 1,
      ease: 'power2.out',
    });
  }
}
